import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Nav } from 'react-bootstrap';

import logo from 'assets/images/logo.png';
import vendorBg from 'assets/images/vendor-bg.png';
import { setAuthorization } from 'helpers/api/apiCore';

const TempleLayout = () => {
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem('temple');
        localStorage.removeItem('templeId');
        localStorage.removeItem('templeAccessToken');
        localStorage.removeItem('templeRefreshToken');

        setAuthorization('');

        navigate('/account/temple-login', { replace: true });
    };

    return (
        <div
            style={{
                minHeight: '100vh',
                backgroundImage: `url(${vendorBg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
            }}
        >
            <div className="border-bottom bg-white py-3 shadow-sm">
                <div className="d-flex align-items-center justify-content-center gap-2">
                    <img src={logo} alt="MyKratu" height={45} />
                    <h4 className="mb-0 fw-bold">
                        MyKratu Temple Admin
                    </h4>
                </div>
            </div>

            <Container fluid className="py-4 px-4">
                <Row>
                    <Col lg={3} xl={2}>
                        <Card>
                            <Card.Body className="p-2">
                                <Nav className="flex-column">

                                    <Nav.Link
                                        as={NavLink}
                                        to="/apps/temple/dashboard"
                                        end
                                    >
                                        <i className="mdi mdi-view-dashboard-outline me-2" />
                                        Dashboard
                                    </Nav.Link>

                                    <Nav.Link
                                        as={NavLink}
                                        to="/apps/temple"
                                        end
                                    >
                                        <i className="mdi mdi-bank me-2" />
                                        Temple Management
                                    </Nav.Link>

                                    <Nav.Link
                                        as={NavLink}
                                        to="/apps/temple/approval-requests"
                                    >
                                        <i className="mdi mdi-account-check-outline me-2" />
                                        Approval Requests
                                    </Nav.Link>

                                    <hr />

                                    <Nav.Link
                                        onClick={handleLogout}
                                        className="text-danger"
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <i className="mdi mdi-logout me-2" />
                                        Logout
                                    </Nav.Link>

                                </Nav>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col lg={9} xl={10}>
                        <Outlet />
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default TempleLayout;